// extracted by mini-css-extract-plugin
module.exports = {"blockForm":"new-user-form_blockForm__3UTlQ","blockFormItem":"new-user-form_blockFormItem__2vNbB","blockAction":"new-user-form_blockAction__1NCg-"};